function isTruthy(value) {
    if (value)
        return true;
    else
        return false;
}

export { isTruthy as default };
